import React, { Component } from 'react';
import { IconButton, Stack, TextField, Dropdown, Spinner, Toggle } from 'office-ui-fabric-react';
import { MyContext } from '../../../../context';
import { queryAllAdherencePhrases } from "../../AdherencePhrases/AdherencePhrasesQuery"
import { queryAllAIQuestions } from '../../AIQuestion/AIQuestionQuery';
import { queryAllAdherencePhrases as queryAllAIAdherencePhrases } from "../../AIAdherencePhrases/AIAdherencePhrasesQuery"
import AlertBar from '../../../CustomComponents/AlertBar';
import { Query } from 'react-apollo';
import ScorecardFolding from '../../../DetailView/DetailPivot/PivotElements/QualityManagement/ScorecardFolding';

export default class EditScorecardSectionEvaluation extends Component {

    static contextType = MyContext


    render() {
        const { indexEvaluation, evaluation } = this.props
        const isOpen = this.props.selectedKeyEvaluation.includes(indexEvaluation)

        return (
            <div>
                <Stack horizontal style={{marginLeft:"10px"} }>
                    <ScorecardFolding
                        selectedKey={this.props.selectedKeyEvaluation}
                        selected={indexEvaluation}
                        open={() => {
                            this.props.updateSelectedKeyEvaluation([...this.props.selectedKeyEvaluation, indexEvaluation])
                        }}
                        close={() => {
                            this.props.updateSelectedKeyEvaluation(this.props.selectedKeyEvaluation.filter(s => s !== indexEvaluation))
                        }}
                    />
                    <IconButton
                        iconProps={{ iconName: 'Delete' }}
                        onClick={() => this.props.deleteEvaluation(indexEvaluation)}
                    />
                    {isOpen &&
                        <h5>{this.context.getTranslation("compliance", "evaluation")}</h5>
                    }
                    {!isOpen &&
                        <h5>{evaluation.itemType == "" ? this.context.getTranslation("compliance", "evaluation") : this.context.getTranslation("compliance", evaluation.itemType)}</h5>
                    }
                </Stack>
                {isOpen && <div>
                    <Stack horizontal style={{ marginLeft: "40px" }}>
                        <Stack.Item align="center" grow>
                            <Dropdown
                                placeholder={this.context.getTranslation("compliance", "selectCriteria")}
                                label=""
                                selectedKey={evaluation.itemType}
                                onChange={(e, item) => { this.props.updateEvaluationField(item.key, indexEvaluation, "itemType") }}
                                options={this.props.availableAreas}
                            />
                        </Stack.Item>
                    </Stack>
                    {evaluation.itemType !== "" &&
                        <Stack style={{ marginLeft: "30px" }}>
                            <Stack.Item>
                                <Stack horizontal style={{ marginTop: "10px" }} >
                                    <Stack.Item grow={3} style={{ marginRight: "10px", marginLeft:"10px" }}>
                                        {evaluation.itemType === "AdherencePhrases" &&
                                            <Query query={queryAllAdherencePhrases}>
                                                {({ loading, error, data, refetch }) => {
                                                    if (loading) return <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                                                    if (error) {
                                                        console.log(error)
                                                        return (
                                                            <AlertBar message={this.context.getTranslation("compliance", "error")} alertType="error" />
                                                        );
                                                    }
                                                    if (data.getAdherencePhrases == null) {
                                                        return <AlertBar message={this.context.getTranslation("compliance", "noAdherencePhrases")} alertType={"warning"} />
                                                    }
                                                    let adherencePhrases = data.getAdherencePhrases.map(v => {
                                                        return {
                                                            "key": v.masterItemId,
                                                            "text": v.name.length > 50 ? v.name.slice(0, 50) + '...' : v.name
                                                        }
                                                    })
                                                    return (
                                                        <Dropdown
                                                            placeholder={this.context.getTranslation("compliance", "selectPhrase")}
                                                            selectedKey={evaluation.itemId}
                                                            onChange={(e, item) => {
                                                                this.props.updateEvaluationField(item.key, indexEvaluation, "itemId")
                                                            }}
                                                            options={adherencePhrases}
                                                        />
                                                    )
                                                }}
                                            </Query>
                                        }
                                        {evaluation.itemType === "AIQuestions" &&
                                            <Query query={queryAllAIQuestions}>
                                                {({ loading, error, data, refetch }) => {
                                                    if (loading) return <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                                                    if (error) {
                                                        console.log(error)
                                                        return (
                                                            <AlertBar message={this.context.getTranslation("compliance", "error")} alertType="error" />
                                                        );
                                                    }
                                                    if (data.getAIQuestions == null) {
                                                        return <AlertBar message={this.context.getTranslation("common", "noData")} alertType={"warning"} />
                                                    }
                                                    let aIQuestions = data.getAIQuestions.map(v => {
                                                        return {
                                                            "key": v.masterItemId,
                                                            "text": v.name.length > 50 ? v.name.slice(0, 50) + '...' : v.name
                                                        }
                                                    })
                                                    return (
                                                        <Dropdown
                                                            placeholder={this.context.getTranslation("compliance", "selectAIQuestion")}
                                                            selectedKey={evaluation.itemId}
                                                            onChange={(e, item) => {
                                                                this.props.updateEvaluationField(item.key, indexEvaluation, "itemId")
                                                            }}
                                                            options={aIQuestions}
                                                        />
                                                    )
                                                }}
                                            </Query>}
                                        {evaluation.itemType === "AIAdherencePhrases" &&
                                            <Query query={queryAllAIAdherencePhrases}>
                                                {({ loading, error, data, refetch }) => {
                                                    if (loading) return <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                                                    if (error) {
                                                        console.log(error)
                                                        return (
                                                            <AlertBar message={this.context.getTranslation("compliance", "error")} alertType="error" />
                                                        );
                                                    }
                                                    if (data.getAIAdherencePhrases == null) {
                                                        return <AlertBar message={this.context.getTranslation("common", "noData")} alertType={"warning"} />
                                                    }
                                                    let adherencePhrases = data.getAIAdherencePhrases.map(v => {
                                                        return {
                                                            "key": v.masterItemId,
                                                            "text": v.name.length > 50 ? v.name.slice(0, 50) + '...' : v.name
                                                        }
                                                    })
                                                    return (
                                                        <Dropdown
                                                            placeholder={this.context.getTranslation("compliance", "selectAIAdherencePhrases")}
                                                            selectedKey={evaluation.itemId}
                                                            onChange={(e, item) => {
                                                                this.props.updateEvaluationField(item.key, indexEvaluation, "itemId")
                                                            }}
                                                            options={adherencePhrases}
                                                        />
                                                    )
                                                }}
                                            </Query>
                                        }
                                        {evaluation.itemType === "QMQuestions" &&
                                            <TextField
                                                placeholder={this.context.getTranslation("compliance", "insertQMQuestions")}
                                                value={evaluation.itemValue}
                                                onChange={(e) => this.props.updateEvaluationField(e.target.value, indexEvaluation, "itemValue")}
                                            />
                                        }
                                        {evaluation.itemType === "ManualQMQuestions" &&
                                            <TextField
                                            placeholder={this.context.getTranslation("compliance", "insertManualQMQuestions")}
                                                value={evaluation.itemValue}
                                                onChange={(e) => this.props.updateEvaluationField(e.target.value, indexEvaluation, "itemValue")}
                                            />
                                        }
                                    </Stack.Item>
                                    <Stack.Item style={{ width: "80px" }}>
                                        <TextField
                                            value={evaluation.points}
                                            type={"number"}
                                            min={0}
                                            onChange={(event, newValue) => {
                                                this.props.updateEvaluationField(parseFloat(newValue), indexEvaluation, "points")
                                            }}
                                        />
                                    </Stack.Item>
                                </Stack>
                            </Stack.Item>
                            {(evaluation.itemType === "AIQuestions" || evaluation.itemType === "QMQuestions" || evaluation.itemType === "ManualQMQuestions") &&
                                <Stack.Item style={{ marginTop: "10px", marginLeft:"10px" }}>
                                    <Toggle
                                        checked={evaluation.awareOfPoints}
                                        onText={this.context.getTranslation("compliance", "awareOfPoints")}
                                        offText={this.context.getTranslation("compliance", "yesNoQuestion")}
                                        onChange={(e, checked) => {
                                            this.props.updateEvaluationField(checked, indexEvaluation, "awareOfPoints")
                                        }}
                                    />
                                </Stack.Item>
                            }
                        </Stack>}
                </div>}
            </div>
        )
    }
}